import React, {ReactNode} from "react";
import {
    ArrowLeftRight, BarChart, BarChartLineFill,
    BarChartSteps,
    Bezier2,
    Box,
    BoxArrowDown,
    BoxArrowInUp,
    BoxFill, Braces,
    BracesAsterisk, Calendar2Plus,
    Calendar2Range, Calendar2RangeFill, Calendar2Week,
    CalendarDay,
    CalendarFill,
    CalendarRange,
    CalendarWeek,
    ColumnsGap, CurrencyExchange,
    Cursor,
    Download,
    Dropbox,
    FileEarmarkArrowUp,
    GearFill,
    HouseDoorFill,
    InfoCircle,
    InfoCircleFill,
    List,
    Pencil,
    PeopleFill,
    Person, PersonLinesFill,
    PlusCircle,
    Substack, Tags,
    TagsFill
} from "react-bootstrap-icons";

export interface AdminMenuInterface {
    left: {
        [key: string]: {
            name: string;
            icon: ReactNode
        }
    };
    right: {
        [key: string]: {
            [key: string]: {
                path: string;
                name: string;
                icon: ReactNode;
                hidden?: boolean
            }
        }
    }
}

export const adminMenu: AdminMenuInterface = {
    left: {
        home: {name: "home", icon: <HouseDoorFill/>},
        tasks: {name: "tasks", icon: <BoxFill/>},
        product: {name: "products", icon: <TagsFill/>},
        user: {name: "users", icon: <PeopleFill/>},
        client: {name: "clients", icon: <PersonLinesFill/>},
        report: {name: "reports", icon: <CurrencyExchange/>},
        settings: {name: "settings", icon: <GearFill/>}
    },
    right: {
        home: {
            // "info/main": {path: "/info/main", name: "main-info", icon: <BodyText/>},
            "info/session": {path: "/info/session", name: "session-info", icon: <CalendarRange/>},
            "info/daily": {path: "/info/daily", name: "daily-info", icon: <CalendarDay/>},
            "info/weekly": {path: "/info/weekly", name: "weekly-info", icon: <CalendarWeek/>},
            "info/all": {path: "/info/all", name: "all-info", icon: <CalendarFill/>},
            "info/status": {path: "/info/status", name: "status-informations", icon: <InfoCircleFill/>},
            "storage/empty-storages": {path: "/storage/empty-storages", name: "empty-storages", icon: <Dropbox/>},
            "storage/missing-storage": {
                path: "/storage/missing-storage",
                name: "missing-storage",
                icon: <Braces/>
            },
            "storage/damaged-storage": {
                path: "/storage/damaged-storage",
                name: "damaged-storage",
                icon: <BracesAsterisk/>
            },
            "subscription/info": {
                path: "/subscription/info",
                name: "subscription-info",
                icon: <Substack/>
            },
        },
        tasks: {
            "order/list": {path: "/order/list", name: "list-order", icon: <Box/>},
            "order/details": {
                path: "/order/details/(.*)",
                name: "order-details",
                icon: <InfoCircleFill/>,
                hidden: true
            },
            // "order/prepare": {path: "/order/prepare", name: "prepare-order", icon: <Hammer/>},
            "order/edit": {path: "/order/edit/(.*)", name: "edit-order", icon: <Pencil/>, hidden: true},
            "receipt/list": {path: "/receipt/list", name: "list-receipt", icon: <BoxArrowInUp/>},
            "receipt/details": {
                path: "/receipt/details/(.*)",
                name: "receipt-details",
                icon: <InfoCircleFill/>,
                hidden: true
            },
            "receipt/edit": {path: "/receipt/edit/(.*)", name: "edit-receipt", icon: <Pencil/>, hidden: true},
            "shipment/list": {path: "/shipment/list", name: "list-shipment", icon: <BoxArrowDown/>},
            "shipment/details": {
                path: "/shipment/details/(.*)",
                name: "shipment-details",
                icon: <InfoCircleFill/>,
                hidden: true
            },
            "shipment/edit": {path: "/shipment/edit/(.*)", name: "edit-shipment", icon: <Pencil/>, hidden: true},
            "transfer-product/list": {
                path: "/transfer-product/list",
                name: "list-transfer-product",
                icon: <ArrowLeftRight/>
            },
            "transfer-product/details": {
                path: "/transfer-product/details/(.*)",
                name: "transfer-product-details",
                icon: <InfoCircleFill/>,
                hidden: true
            },
            // "transfer-product/edit": {path: "/transfer-product/edit/(.*)", name: "edit-transfer-product", icon: <Pencil/>, hidden: true}
            "order-schedule/list": {path: "/order-schedule/list", name: "order-schedule", icon: <Calendar2Range/>},
            "order-schedule/details": {
                path: "/order-schedule/details/(.*)",
                name: "order-schedule-details",
                icon: <Calendar2RangeFill/>,
                hidden: true
            },
            "order-schedule/create": {
                path: "/order-schedule/create",
                name: "create-order-schedule",
                icon: <Calendar2Plus/>,
                hidden: true
            },
            "order-schedule/edit": {
                path: "/order-schedule/edit/(.*)",
                name: "edit-order-schedule",
                icon: <Calendar2Week/>,
                hidden: true
            },
        },
        product: {
            "product/list": {path: "/product/list", name: "list-product", icon: <List/>},
            // "product/create": {path: "/product/create", name: "create-product", icon: <PlusCircle/>},
            "product/details": {
                path: "/product/details/(.*)",
                name: "product-details",
                icon: <InfoCircleFill/>,
                hidden: true
            },
            "product-category/list": {
                path: "/product-category/list",
                name: "list-product-category",
                icon: <ColumnsGap/>
            },
            // "product-category/create": {
            //     path: "/product-category/create",
            //     name: "create-product-category",
            //     icon: <PlusCircle/>
            // },
            "product-category/edit": {
                path: "/product-category/edit/(.*)",
                name: "edit-product-category",
                icon: <Pencil/>,
                hidden: true
            },
            "product/history": {path: "/product/history", name: "product-history", icon: <Bezier2/>},
            "product/snapshot-history": {
                path: "/product/snapshot-history",
                name: "snapshot-history",
                icon: <BarChart/>
            },
            "product/snapshot-compare": {
                path: "/product/snapshot-compare",
                name: "snapshot-compare",
                icon: <BarChartSteps/>
            },
            "product/missing": {path: "/product/missing", name: "product-missing-list", icon: <Braces/>},
            "product/damaged": {path: "/product/damaged", name: "product-damaged-list", icon: <BracesAsterisk/>},
            "product/edit": {path: "/product/edit/(.*)", name: "edit-product", icon: <Pencil/>, hidden: true},
            // "product/import": {path: "/product/import", name: "import-product", icon: <FileEarmarkArrowUp/>},
            "product/export": {
                path: "/product/export",
                name: "product-export",
                icon: <Download/>, hidden: true
            },
        },
        report: {
            "report/warehouse-value": {path: "/report/warehouse-value", name: "warehouse-value", icon: <Tags/>},
            "report/daily-performance": {path: "/report/daily-performance", name: "daily-performance", icon: <BarChartLineFill/>},
        },
        user: {
            "user/list": {path: "/user/list", name: "list-user", icon: <List/>},
            "user/create": {path: "/user/create", name: "create-user", icon: <PlusCircle/>},
            "user/edit": {path: "/user/edit/(.*)", name: "edit-user", icon: <Pencil/>, hidden: true},
            "user/change-password": {
                path: "/user/change-password", name: "change-password", icon: <Pencil/>, hidden: true
            },
            "user/edit-permissions": {
                path: "/user/edit-permissions",
                name: "edit-permissions-user",
                icon: <Pencil/>,
                hidden: true
            }
        },
        client: {
            "client/list": {path: "/client/list", name: "list-client", icon: <List/>},
            "client/create": {path: "/client/create", name: "create-client", icon: <PlusCircle/>},
            "client/edit": {path: "/client/edit/(.*)", name: "edit-client", icon: <Pencil/>, hidden: true},
            "client/edit-users": {path: "/client/edit-users", name: "edit-client-users", icon: <Pencil/>, hidden: true}
        },
        settings: {
            "settings/my-profile": {path: "/settings/my-profile", name: "my-profile", icon: <Person/>},
            "settings/index": {path: "/settings/index", name: "language-settings", icon: <InfoCircle/>},
            "linguistic-values/list": {path: "/linguistic-values/list", name: "list-linguistic-value", icon: <List/>},
            "linguistic-values/create": {
                path: "/linguistic-values/create",
                name: "create-linguistic-values",
                icon: <PlusCircle/>
            },
            "linguistic-values/import": {
                path: "/linguistic-values/import",
                name: "import-linguistic-values",
                icon: <FileEarmarkArrowUp/>
            },
            "linguistic-values/export": {
                path: "/linguistic-values/export",
                name: "export-linguistic-values",
                icon: <Download/>, hidden: true
            },
            "linguistic-values/missing": {
                path: "/linguistic-values/missing",
                name: "missing-linguistic-values",
                icon: <PlusCircle/>
            },
            "linguistic-values/edit": {
                path: "/linguistic-values/edit/(.*)/(.*)",
                name: "edit-linguistic-values",
                icon: <Pencil/>, hidden: true
            },
            "logout": {path: "/logout", name: "logout", icon: <Cursor/>, hidden: true}
        }
    }
}